module.exports = __webpack_public_path__ + "static/media/chat.e52c6701.svg";